import { AccessEvent } from '../hooks/useEventStream';

/**
 * Determines if an event was replayed from device buffer (vs. processed in real-time)
 * An event is considered "replayed" if it was processed more than 30 seconds after it occurred
 */
export function isReplayedEvent(event: AccessEvent): boolean {
  const eventTime = new Date(event.event_timestamp).getTime();
  const processedTime = new Date(event.processed_at).getTime();
  const diffSeconds = (processedTime - eventTime) / 1000;

  // Events processed >30s after occurrence are likely from device buffer
  return diffSeconds > 30;
}

/**
 * Gets the display timestamp for an event based on context
 * @param event - The event
 * @param context - 'realtime' uses processed_at, 'historical' uses event_timestamp
 */
export function getDisplayTimestamp(event: AccessEvent, context: 'realtime' | 'historical'): Date {
  if (context === 'realtime') {
    return new Date(event.processed_at);
  }
  return new Date(event.event_timestamp);
}

/**
 * Formats relative time for real-time views (e.g., "2 segundos atrás")
 */
export function formatRelativeTime(timestamp: Date): string {
  const now = new Date().getTime();
  const diffMs = now - timestamp.getTime();
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffSeconds < 60) return `${diffSeconds}s atrás`;
  if (diffMinutes < 60) return `${diffMinutes}m atrás`;
  if (diffHours < 24) return `${diffHours}h atrás`;
  return `${diffDays}d atrás`;
}
